<template>
  <div class="flex items-center justify-center bg-white px-4">
    <div class="w-full max-w-md text-center">
      <h2 class="text-[22px] font-semibold text-grey-light-400">{{ title }}</h2>

      <p class="mt-2 text-[14px] text-grey-light-400">{{ description }}</p>

      <div class="mt-6 flex flex-col gap-3 sm:flex-row sm:justify-center sm:gap-4">
        <Button
          v-if="variant === 'all' || variant === 'layby'"
          variant="outline"
          @click="navigate('layby')"
          class="w-full text-[14px] justify-center text-grey-light-400 transition hover:bg-brand-50 hover:border-brand-300 hover:text-brand-800 sm:w-auto h-[40px]"
        >
          <Plus />
          Start Digital Lay-By
        </Button>
        <Button
          v-if="variant === 'all' || variant === 'plans'"
          variant="outline"
          @click="navigate('plans')"
          class="w-full text-[14px] justify-center text-grey-light-400 transition hover:bg-brand-50 hover:border-brand-300 hover:text-brand-800 sm:w-auto h-[40px]"
        >
          <Plus />
          Start Payment Plan
        </Button>
        <Button
          v-if="variant === 'all' || variant === 'boost'"
          variant="outline"
          @click="navigate('boost')"
          class="w-full text-[14px] justify-center text-grey-light-400 transition hover:bg-brand-50 hover:border-brand-300 hover:text-brand-800 sm:w-auto h-[40px]"
        >
          <Plus />
          Start Savings Plan
        </Button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Button } from '@/components/ui/button';
import { useShopsStore } from '@/stores/shops';
import { Plus } from 'lucide-vue-next';
import { useRouter } from 'vue-router';

defineProps<{
  title?: string;
  description?: string;
  variant?: 'layby' | 'plans' | 'boost' | 'all';
}>();

const router = useRouter();
const shopsStore = useShopsStore();

const navigate = (product: 'layby' | 'plans' | 'boost') => {
  shopsStore.currentProduct = product;
  router.push({ name: 'shopperStores', query: { source: 'empty_state' } });
};
</script>
